import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { css, ThemeContext } from "styled-components";
import ToastContext from "./ToastContext";
import composeRefs from "@seznam/compose-react-refs";
import { SuccessMd, WarningMd } from "../icons";
import { replaceToken } from "../../private/helpers";
import { ToastContainer, openCloseBase, quickCloseAnimation, closeSwap, ToastElement, IconContainer, ActionButton } from "./styles";
var Toast = function Toast(_ref) {
  var activeToast = _ref.activeToast,
    requestClose = _ref.requestClose;
  var _useContext = useContext(ToastContext),
    removeToast = _useContext.removeToast;
  var theme = useContext(ThemeContext);
  var toastRef = useRef(null);
  var message = activeToast.message,
    action = activeToast.action,
    _activeToast$variant = activeToast.variant,
    variant = _activeToast$variant === void 0 ? "success" : _activeToast$variant,
    _activeToast$placemen = activeToast.placement,
    placement = _activeToast$placemen === void 0 ? "bottom" : _activeToast$placemen,
    _activeToast$offset = activeToast.offset,
    offset = _activeToast$offset === void 0 ? "medium" : _activeToast$offset,
    className = activeToast.className,
    style = activeToast.style,
    ref = activeToast.ref,
    dangerouslySetClassNames = activeToast.dangerouslySetClassNames;
  var offsetString = replaceToken(theme.spacing, offset);
  var _useState = useState(false),
    quickClose = _useState[0],
    setQuickClose = _useState[1];
  useEffect(function () {
    var toast = toastRef.current;
    if (!toast) return;
    toast.addEventListener("animationend", requestClose || removeToast);
    return function () {
      return toast.removeEventListener("animationend", requestClose || removeToast);
    };
  }, [requestClose, removeToast]);
  var getAnimation = function getAnimation() {
    if (requestClose) return css(["animation:", " 100ms forwards;"], closeSwap(placement, offsetString));else if (quickClose) return css(["animation:", " 300ms;"], quickCloseAnimation);
    return css(["animation:", " 6s forwards;"], openCloseBase(placement));
  };
  return /*#__PURE__*/React.createElement(ToastContainer, {
    placement: placement,
    $offset: offsetString,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(ToastElement, {
    key: message,
    ref: composeRefs(ref, toastRef),
    animation: getAnimation(),
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.toastElement,
    role: "alert"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    variant: variant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.iconContainer
  }, variant === "warning" ? /*#__PURE__*/React.createElement(WarningMd, null) : /*#__PURE__*/React.createElement(SuccessMd, null)), message, action && /*#__PURE__*/React.createElement(ActionButton, {
    variant: "naked",
    sizeVariant: "medium",
    compact: true,
    onClick: function onClick() {
      action.onClick();
      setQuickClose(true);
    },
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.actionButton
  }, action.label)));
};
export default Toast;